module.exports = __webpack_public_path__ + "static/img/GU.0c6e9a7a.jpg";